"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Redacted = void 0;
/** @private  */
var Redacted = exports.Redacted = '[:REDACTED:]'; // distinguish from redacted string returned by the redact library.

/**
 * A system to
 * 1. decide whether you want to redact a given piece of information
 * 2. actually redact the information
 *
 * Redaction rules are called both recursively on object properties, and at the root of the
 * recursion. Therefore, the test function may get called with or without propertyName.
 */